import { Title } from "@components/ui/Title";
import { useSearch } from "@helpers/context/SearchContext";
import { t } from "@helpers/translate";
import React, { FC } from "react";

type IPorps = {
  title?: string;
  countryName?: string;
  cityName?: string;
};

export const Header: FC<IPorps> = ({ title, countryName, cityName }) => {
  const { filters } = useSearch();

  const getTitle = () => {
    const isKWSearch = !filters.city && !filters.country && filters.q;
    const query = filters.q;

    if (isKWSearch) {
      return t({
        id: "search.header.keyword",
        message: `Results for "${query}"`,
        values: {
          query: `${query}`,
        },
      });
    }

    const locationName = filters.city
      ? cityName
      : filters.country
        ? countryName
        : undefined;

    if (!locationName) {
      return t({
        id: "search.header.default",
        message: `Search Results`,
      });
    }

    if (filters.t === "guides") {
      return t({
        id: "search.header.location-suppliers",
        message: `${locationName} Local Guides`,
        values: {
          locationName: `${locationName}`,
        },
      });
    }

    if (filters.t === "online-tours") {
      return t({
        id: "search.header.online-tours",
        message: `${locationName} Virtual Tours`,
        values: {
          locationName: `${locationName}`,
        },
      });
    }

    if (filters.t === "transportation") {
      return t({
        id: "search.header.transportation",
        message: `${locationName} Private Cars`,
        values: {
          locationName: `${locationName}`,
        },
      });
    }

    if (filters.t === "tours") {
      return t({
        id: "search.header.location-tours",
        message: `${locationName} Private Tours`,
        values: {
          locationName: `${locationName}`,
        },
      });
    }

    return t({
      id: "search.header.location-tours",
      message: `${locationName} Private Tours`,
      values: {
        locationName: `${locationName}`,
      },
    });
  };

  return (
    <div>
      <div className="block mb-6 mb:mb-0">
        <Title as="h1" size="lg" className="mb-4">
          {title || getTitle()}
        </Title>
      </div>
    </div>
  );
};
